import React from 'react';
import { FormattedMessage } from 'react-intl';
import style from './fullPageMessage.module.scss';
import buttonStyle from 'acscp/components/common/buttons.module.scss';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { chartersList, home } from 'acscp/components/routeHelper';

interface FullPageMessageProps {
    title: React.ReactNode;
    message: React.ReactNode;
    buttons: React.ReactNode;
    containerClassName?: string;
}

const FullPageMessage: React.SFC<FullPageMessageProps> = (props: FullPageMessageProps) => {
    return (
        <div className={classNames(style.Container, props.containerClassName)}>
            <div className={style.NarrowInner}>
                <h1 className={style.Header}>
                    {props.title}
                </h1>
                <div className={style.Message}>
                    {props.message}
                </div>
                {props.buttons}
            </div>
        </div>
    );
};

const FullPageMessageGoToRootButton: JSX.Element = (
    <Link to={home()} className={buttonStyle.BasicButton}>
        <FormattedMessage
            id={'components.fullPageMessage.returnToJetPortal'}
            defaultMessage={'Return to JetPortal'}
        />
    </Link>
);

const FullPageMessageGoToMyChartersButton: JSX.Element = (
    <Link to={chartersList()} className={buttonStyle.BasicButton}>
        <FormattedMessage
            id={'components.fullPageMessage.returnToMyCharters'}
            defaultMessage={'Return to My Charters'}
        />
    </Link>
);

export { FullPageMessage, FullPageMessageGoToRootButton, FullPageMessageGoToMyChartersButton };
